module.exports = require("@swa-ui/design-tokens/src/generated/platforms/scss/internal.module.scss");